var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-tag-icon',{attrs:{"icon-size":16,"text-size":12,"border":0,"text":_vm.restOfTime,"iconColor":"#0091FF","icon":"fal fa-hourglass-start","color":"#566889"}})
}
var staticRenderFns = []

export { render, staticRenderFns }